import * as React from "react";

const fields = (t) => ({
    config: {columns: 1},
    fields: [
        {
            name: "value",
            label: t ? t("common.add_symbol") : "Dodaj symbol",
            column: 1,
        },


    ]
});

export default fields;
